<style lang="scss" scoped>
.header-search {
    position: relative;

    &:before {
        content: url("/svg/search-small-dark.svg");
        width: 16px;
        height: 16px;
        position: absolute;
        left: 16px;
        top: 2px;

        @media (min-width: 1024px) and (max-width: 1365.98px) {
            left: 10px;
        }
    }

    &:focus {
        outline: none;
        box-shadow: none;
    }

    input {
        border-color: rgba(23, 35, 64, 0.3);
        background-color: transparent !important;
        height: 40px;
        font-size: 1rem;
        font-weight: 300;
        color: #172340 !important;
        padding-left: 48px;
        padding-right: 60px;
        position: relative;
        transition: border-color 0.15s;
        max-width: 392px;
        width: 100%;

        @media (min-width: 1280px) and (max-width: 1365.98px) {
            font-size: 14px;
            padding-right: 40px;
            padding-left: 32px;
        }

        &:focus {
            outline: none;
            border-color: #172340;
            box-shadow: none;
        }
    }

    .search-submit {
        position: absolute;
        top: 0;
        right: 0;
        height: 40px;
        width: 60px;
        cursor: pointer;

        @media (min-width: 1024px) and (max-width: 1365.98px) {
            width: 40px;
        }

        .arrow-right-small {
            content: url("/svg/arrow-right-small-dark.svg");
            width: 26px;
            height: 11px;
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            transition: left 0.15s;
        }

        &:hover {
            .arrow-right-small {
                left: calc(50% + 4px);

                @media (min-width: 1024px) and (max-width: 1365.98px) {
                    left: calc(50% + 2px);
                }
            }
        }
    }
}
</style>

<template>
    <div class="header-search ml-md-24 ml-xl-80 align-self-center mr-xl-auto">
        <input :id="inputId" tabindex="1" class="form-control" type="text" v-model="searchText" @keyup.enter="submitSearch" placeholder="Probeer 'Vuurdoop'">
        <div class="search-submit" @click="submitSearch"><span class="arrow-right-small"></span></div>
    </div>
</template>

<script>
import activitiesSearch from "../mixins/activities-search";

export default {
    name: "elements.header-search",

    mixins: [activitiesSearch],

    props: {
        inputId: {
            type: String,
            required: false,
        }
    },

    created() {
        let params = new URLSearchParams(location.search)

        params.forEach((value, key) => {
            if (key === 'search') {
                this.searchText = value
                return
            }
        })
    },

}
</script>
